import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemingService } from './core/services/theming.service';
import { IdleService } from './core/services/idle.service';
import { environment } from '../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'cayc-front';
  // @ts-ignore
  favicon: HTMLLinkElement = document.querySelector('#appIcon');
  @ViewChild('staticBackdropModal') staticBackdropModal: ElementRef | undefined;
  modalRef: any;

  constructor(
    private ts: ThemingService,
    private idleService: IdleService,
    private modalService: NgbModal,
    private router: Router,
    private location: Location,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    const appData = sessionStorage.getItem('appData');
    if (appData !== null) {
      this.favicon.href = 'data:image/png;base64,' + JSON.parse(appData).icon;
      this.ts.setCompanyTheme();
    }
    this.initialIdleSettings();
    this.initializeTranslation();
  }

  /**
   * Inicializar la traducción
   */
  private initializeTranslation() {
    this.translateService.addLangs(['en', 'es']);
    this.translateService.setDefaultLang('es');
    const browserLang = 'es';
    this.translateService.use(browserLang);
  }

  /**
   * Configurar el tiempo de inactividad
   */
  private initialIdleSettings() {
    const idleTimeoutInSeconds: number = environment.idleTimeInMinutes * 60;
    this.idleService
      .startWatching(idleTimeoutInSeconds)
      .subscribe((isTimeOut: boolean) => {
        if (isTimeOut) {
          if (!this.location.path().includes('auth')) {
            this.modalRef = this.modalService.open(this.staticBackdropModal, {
              centered: true,
              backdrop: 'static',
              keyboard: false,
            });
            this.idleService.stopTimer();
          }
        }
      });
  }

  /**
   * Cerrar sesión
   */
  logOut() {
    this.modalService.dismissAll();
    this.router.navigate(['/auth/logout']);
  }
}
